export const ServerConfiguration = {
    testingServerUrl: "https://tourism.denoo.my/BESarawakDevAPI/api/BESarawakApi/",
    LiveServerUrl: "https://tourism.denoo.my/BESarawakDevAPI/api/BESarawakApi/",
    uploadUrl: "https://tourism.denoo.my/BESarawakDevAPI/api/BESarawakApi/upload.php",
  }